import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { ProfilePictureEditorCard } from '@components/ProfilePicture';
import { createPepHealthService } from '@api/createPepHealthService';
import { selectCurrentDashboardUser } from '@redux/login/reducer';
import { updateDirectChildOrganisationUserProfilePicture } from '@redux/directChildOrganisationAdministration/actions';

/**
 * Direct Child Organisation User mount for the reusable Profile Picture editor.
 */
function DirectChildOrganisationUserProfilePictureCard({
  organisationSlug,
  userId,
  displayName,
  initialImageId,
  initialImageUrl,
}) {
  const dispatch = useDispatch();
  const actor = useSelector(selectCurrentDashboardUser);
  const [api, setApi] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    createPepHealthService()
      .then(service => {
        if (!cancelled) setApi(service);
      })
      .catch(err => {
        console.error(err);
        if (!cancelled) setError(err);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const onCanonicalChange = useCallback(
    canonical => {
      dispatch(
        updateDirectChildOrganisationUserProfilePicture(Number(userId), {
          profilePictureImageId: canonical.profilePictureImageId,
          profilePictureUrl: canonical.profilePictureUrl,
        }),
      );
    },
    [dispatch, userId],
  );

  if (error || !organisationSlug) {
    return null;
  }

  if (!api) {
    return null;
  }

  return (
    <ProfilePictureEditorCard
      api={api}
      organisationSlug={organisationSlug}
      userId={Number(userId)}
      displayName={displayName}
      actorId={actor && actor.id}
      initialCanonical={{
        profilePictureImageId: initialImageId == null ? null : initialImageId,
        profilePictureUrl: initialImageUrl == null ? null : initialImageUrl,
      }}
      onCanonicalChange={onCanonicalChange}
    />
  );
}

DirectChildOrganisationUserProfilePictureCard.propTypes = {
  organisationSlug: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  displayName: PropTypes.string.isRequired,
  initialImageId: PropTypes.string,
  initialImageUrl: PropTypes.string,
};

DirectChildOrganisationUserProfilePictureCard.defaultProps = {
  organisationSlug: null,
  initialImageId: null,
  initialImageUrl: null,
};

export default DirectChildOrganisationUserProfilePictureCard;
